import { render } from "./DialysisSectionDetails.vue?vue&type=template&id=3628b7a1&scoped=true"
import script from "./DialysisSectionDetails.vue?vue&type=script&lang=js"
export * from "./DialysisSectionDetails.vue?vue&type=script&lang=js"

import "./DialysisSectionDetails.vue?vue&type=style&index=0&id=3628b7a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3628b7a1"],['__file',"src/components/DialysisSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3628b7a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3628b7a1', __exports__)) {
    api.reload('3628b7a1', __exports__)
  }
  
  module.hot.accept("./DialysisSectionDetails.vue?vue&type=template&id=3628b7a1&scoped=true", () => {
    api.rerender('3628b7a1', render)
  })

}


export default __exports__